import { useState } from 'react'
import { PropertiesTab } from './PropertiesTab'
import { ArrowSquareLeftIcon } from '@phosphor-icons/react'
import {
    ScoopTab,
    ScoopDrawer,
    ScoopSelector,
    ScoopButton,
    ScoopText,
    ScoopColorPicker,
    ScoopColumn,
} from '../../../../../ui'
import styles from './RightPanel.module.scss'

const rightDrawerTabs = [
    { label: 'Properties', key: 'properties' },
    { label: 'Style', key: 'style' },
]

export const RightPanel = ({
    diagramState,
    onToggleShowNodes,
    diagramSetNodeColor,
    diagramSetBackgroundColor,
    displayLinksAboveThreshold,
    diagramSetIsSankey,
    handleFetchSankey,
    diagramSetSankeyNumberOfSteps,
    diagramSetSankeyPeriod,
    diagramSetSankeyIsStepBased,
    diagramSetAllowedStartingValues,
    generateOptionsDropdownSankeyStartingValues,
    startingValuesOptions,
    isOpen,
    setIsOpen,
    diagramSetStep,
    diagramSetPathColor,

    //Theme Select
    themeDropdownOptions,
    diagramSetTheme,
}) => {
    const [selectedRightTab, setSelectedRightTab] = useState(rightDrawerTabs[0].key)

    return (
        <div>
            <div>
                <ScoopButton
                    variant="text"
                    size="xxs"
                    onClick={() => setIsOpen(!isOpen)}
                    className={`${styles.toggleButton} ${isOpen ? styles.toggleButtonOpen : ''}`}
                    aria-label={isOpen ? 'Close right panel' : 'Open right panel'}
                >
                    <ArrowSquareLeftIcon
                        size={18}
                        weight="regular"
                        className={`${styles.toggleIcon} ${isOpen ? styles.toggleIconRotated : ''}`}
                    />
                </ScoopButton>
            </div>
            <ScoopDrawer open={isOpen} anchor="right" variant="persistent" width={300}>
                <div className={styles.tabContainer}>
                    <ScoopTab
                        tabs={rightDrawerTabs}
                        value={selectedRightTab}
                        onChange={(e, value) => setSelectedRightTab(value)}
                    />
                </div>
                <ScoopColumn className={styles.contentContainer}>
                    {selectedRightTab === rightDrawerTabs[0].key ? (
                        <PropertiesTab
                            diagramSelected={diagramState.isSankey ? 'sankey' : 'process'}
                            onChangeDiagramSelected={(value) => {
                                diagramSetIsSankey(value === 'sankey' ? true : false)
                            }}
                            diagramState={diagramState}
                            displayLinksAboveThreshold={displayLinksAboveThreshold}
                            handleFetchSankey={handleFetchSankey}
                            diagramSetSankeyNumberOfSteps={diagramSetSankeyNumberOfSteps}
                            onToggleShowNodes={onToggleShowNodes}
                            diagramSetSankeyPeriod={diagramSetSankeyPeriod}
                            diagramSetSankeyIsStepBased={diagramSetSankeyIsStepBased}
                            diagramSetAllowedStartingValues={diagramSetAllowedStartingValues}
                            generateOptionsDropdownSankeyStartingValues={
                                generateOptionsDropdownSankeyStartingValues
                            }
                            startingValuesOptions={startingValuesOptions}
                            diagramSetStep={diagramSetStep}
                        />
                    ) : (
                        <ScoopColumn className={styles.styleTabContainer}>
                            <ScoopSelector
                                value={
                                    diagramState.theme === 'None'
                                        ? 'None'
                                        : diagramState.theme?.themeID || 'None'
                                }
                                label="Theme"
                                onChange={(e) => diagramSetTheme(e.target.value)}
                                options={[
                                    { label: 'None', value: 'None' },
                                    ...(themeDropdownOptions || []),
                                ]}
                                size="sm"
                            />

                            {diagramState.isSankey ? (
                                <>
                                    <ScoopColumn className={styles.colorPickerGroup}>
                                        <ScoopText className={styles.colorPickerLabel}>
                                            Background color
                                        </ScoopText>
                                        <ScoopColorPicker
                                            value={diagramState.backgroundColor || 'transparent'}
                                            onChange={diagramSetBackgroundColor}
                                            showLabel
                                        />
                                    </ScoopColumn>
                                    <ScoopColumn className={styles.colorPickerGroup}>
                                        <ScoopText className={styles.colorPickerLabel}>
                                            Path color
                                        </ScoopText>
                                        <ScoopColorPicker
                                            value={diagramState.pathColor || '#01213d5a'}
                                            onChange={diagramSetPathColor}
                                            showLabel
                                        />
                                    </ScoopColumn>
                                </>
                            ) : (
                                <>
                                    <ScoopColumn className={styles.colorPickerGroup}>
                                        <ScoopText className={styles.colorPickerLabel}>
                                            Background color
                                        </ScoopText>
                                        <ScoopColorPicker
                                            value={diagramState.backgroundColor || 'transparent'}
                                            onChange={diagramSetBackgroundColor}
                                            showLabel
                                        />
                                    </ScoopColumn>
                                    <ScoopColumn className={styles.colorPickerGroup}>
                                        <ScoopText className={styles.colorPickerLabel}>
                                            Node color
                                        </ScoopText>
                                        <ScoopColorPicker
                                            value={diagramState.nodeColor || '#1e6e53'}
                                            onChange={diagramSetNodeColor}
                                            showLabel
                                        />
                                    </ScoopColumn>
                                </>
                            )}
                        </ScoopColumn>
                    )}
                </ScoopColumn>
            </ScoopDrawer>
        </div>
    )
}
